export function digitsOnly(phone) {
  return (phone || '').replace(/\D/g, '');
}

// web.whatsapp.com (rather than wa.me) so this reliably opens in Chrome.
// wa.me/api.whatsapp.com short links get intercepted by the WhatsApp Desktop
// app on macOS when it's installed, and that app has a confirmed encoding
// bug that corrupts emoji in the text= parameter. Don't use wa.me here --
// see zenya-app's src/lib/whatsapp.js for the original investigation.
export function buildWhatsappUrl(phone, message) {
  return `https://web.whatsapp.com/send?phone=${digitsOnly(phone)}&text=${encodeURIComponent(message)}`;
}
